// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__PlnXL","head":"Table_head__DUYH-","col":"Table_col__1HDCF"};